import React, { Component } from 'react';
import { Button, Dialog, DialogContent, DialogActions, Grid, IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import PrintIcon from '@material-ui/icons/Print';

import { GoCalendar } from 'react-icons/go';
import { MdImageSearch } from 'react-icons/md';
import { FACULTY_INFO } from './FacultyInfo';

// import axios from 'axios';
// import { COMMON_IMG, EVENT_ID, PROGRAM_API_URL } from '../constants';
// import ProgramModal from '../program/ProgramModal';

const moment = require('moment-timezone');
moment.tz.setDefault('Asia/Seoul');

const styles = (theme) => ({
  dialogRoot: {
    minWidth: 'lg',
    '& table': {
      borderTop: `2px solid ${theme.palette.primary.main}`,
      width: '100%',
      borderCollapse: 'collapse',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },

    '& td': {
      padding: '20px',
      color: theme.palette.primary.gray,
      [theme.breakpoints.down('sm')]: {
        padding: '10px',
        fontSize: 12,
      },
    },
    '& th': {
      padding: '10px !important',
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        '& td:first-child': { backgroundColor: '#F2FAFD', fontWeight: 'bold' },
        '& td:last-child': { backgroundColor: '#FCFCFC' },
      },
    },
  },

  contentGrid: {
    // backgroundColor: '#f9f9f9',
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
    },
  },
  tableWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tableMobile: {
    marginBottom: '20px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  closeButton: {
    right: '10px',
    color: '#5b5b5b',
    top: '10px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  listGrid: {
    padding: '20px',
    [theme.breakpoints.down('sm')]: {
      // padding: '0px 10px 10px 10px',
    },
  },

  contentTopPadding: {
    paddingTop: '35px,',
  },

  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F2FAFD',
    color: theme.palette.primary.point,
    fontWeight: 'bold',
    borderLeft: '1px solid ',
    borderBottom: '0px',
    borderColor: 'white',
  },
  body: {
    fontSize: 14,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-child(odd)': {
      backgroundColor: '#FCFCFC',
    },
    '&:nth-child(even)': {
      backgroundColor: '#F6F6F6',
    },
  },
}))(TableRow);

class FacultyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenDetail: false,
      detail: null,
    };
  }

  onPrint = () => {
    const btns = document.getElementsByClassName('detail-btn');
    window.onbeforeprint = () => {
      for (let i = 0; i < btns.length; i++) {
        btns[i].style.visibility = 'hidden';
      }
    };
    window.onafterprint = () => {
      for (let i = 0; i < btns.length; i++) {
        btns[i].style.visibility = 'visible';
      }
    };
    window.print();
  };

  convertEventDate(date) {
    //faculty detail의 실제 행사 날짜를 임시로 변경한 행사날짜로 변환해주는 function

    // Admin에서 임의로 바꾼 행사날짜
    const startDate = JSON.parse(sessionStorage.getItem('Item')).startDate;
    const endDate = JSON.parse(sessionStorage.getItem('Item')).endDate;
    const calDates = moment(endDate).diff(moment(startDate), 'days') + 1;
    let buff = {};
    for (let i = 0; i < calDates; i++) {
      buff[`${Number(startDate) + i}`] = `day${i + 1}`;
    }

    // 실제 행사일자
    const realDates = {
      20210908: 'day1',
      20210909: 'day2',
      20210910: 'day3',
    };

    for (const [rk, rv] of Object.entries(realDates)) {
      if (rk.toString() === date) {
        for (const [dk, dv] of Object.entries(buff)) {
          if (rv === dv) {
            return dk;
          }
        }
      }
    }
  }

  openPgmDetail(program) {
    // const atTitle = program['At Title'].replace(/&/g, '%26');
    // const channel = program['Room'].replace(' ', '0');
    // const pgDate = this.convertEventDate(program['Date'].replace(/\//g, ''));
    // axios
    //   .get(`${PROGRAM_API_URL}/program/infoByTitle?evt=${EVENT_ID}&atTitle=${atTitle}&channel=${channel}&pgDate=${pgDate}`)
    //   .then((response) => {
    //     if (response.data.Items) {
    //       this.setState({ detail: response.data.Items[0], isOpenDetail: true });
    //     }
    //   });
  }

  getSessionData = (PgmId) => {
    return FACULTY_INFO.filter((dt) => dt.id === PgmId).map((sessionDatas, idx) => {
      return (
        <React.Fragment key={`${idx}_web`}>
          <StyledTableCell align="center" width="15%">
            {sessionDatas.sessionTime}
          </StyledTableCell>
          <StyledTableCell align="left" width="40%" style={{ cursor: 'pointer' }}>
            {sessionDatas.pgTitle}
            <p style={{ color: '#555', fontSize: '0.9em' }}>{sessionDatas.pgSub}</p>
          </StyledTableCell>
        </React.Fragment>
      );
    });
  };

  getSessionDataMob = (PgmId) => {
    return FACULTY_INFO.filter((dt) => dt.id === PgmId).map((sessionDatas, idx) => {
      return (
        <React.Fragment key={`${idx}_mob`}>
          <StyledTableRow>
            <StyledTableCell align="center" width="15%">
              Time
            </StyledTableCell>
            <StyledTableCell align="center" width="15%">
              {sessionDatas.sessionTime}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell align="center" width="15%">
              Session/Title
            </StyledTableCell>
            <StyledTableCell align="center" width="15%" style={{ cursor: 'pointer' }}>
              <p style={{ paddingBottom: '5px', fontWeight: 'bold' }}> {sessionDatas.pgTitle}</p>
              <p>{sessionDatas.pgSub}</p>
            </StyledTableCell>
          </StyledTableRow>
        </React.Fragment>
      );
    });
  };
  render() {
    const { classes, open, onClose, selectedData } = this.props;
    // console.log(selectedData);
    return (
      <>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={onClose}
          aria-labelledby="faq-dialog-title"
          open={open || false}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogContent style={{ padding: '0px' }}>
            <Grid container>
              <Grid item xs={false} sm={false} md={12} className={classes.contentGrid}>
                <Grid container>
                  <IconButton onClick={onClose} className={`${classes.closeButton} detail-btn`} style={{ position: 'absolute' }}>
                    <CloseIcon />
                  </IconButton>
                  <Grid container id={'print'} className={classes.contentTopPadding}>
                    <Grid container justifyContent="space-between" alignItems="center" style={{ padding: '10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <GoCalendar size={30} style={{ color: '#035a3c' }} />
                        {/* <img src={`${COMMON_IMG}/ic_live_program.png`} alt="program icon" /> */}
                        <span
                          style={{ color: this.props.theme.palette.primary.main, fontWeight: 'bold', paddingLeft: 15, fontSize: '1.2em' }}
                        >
                          Participation Program List (&nbsp;{selectedData && selectedData.pgm.length}&nbsp;)
                        </span>
                      </div>
                    </Grid>

                    <TableContainer>
                      <Table className={classes.tableWeb} aria-label="customized table">
                        <TableHead>
                          <StyledTableRow>
                            <StyledTableCell align="center" width="15%">
                              Date
                            </StyledTableCell>
                            <StyledTableCell align="center" width="15%">
                              Time
                            </StyledTableCell>
                            <StyledTableCell align="center" width="40%">
                              Session/Title
                            </StyledTableCell>
                            <StyledTableCell align="center" width="15%">
                              Role
                            </StyledTableCell>
                            <StyledTableCell align="center" width="15%">
                              Channel
                            </StyledTableCell>
                          </StyledTableRow>
                        </TableHead>
                        <TableBody>
                          {selectedData && selectedData.pgm.length > 0
                            ? // eslint-disable-next-line
                              selectedData.pgm.map((pgm, idx) => {
                                // console.log(selectedData);
                                if (pgm.Date) {
                                  return (
                                    <StyledTableRow key={'pgm-row-' + idx}>
                                      <StyledTableCell align="center" width="15%">
                                        {moment('2022-' + pgm.Date, 'YYYY-DD-MMM').format('YYYY/MM/DD')}
                                      </StyledTableCell>

                                      {this.getSessionData(pgm.PgmId)}

                                      <StyledTableCell align="center" width="15%">
                                        {pgm.role}
                                      </StyledTableCell>
                                      <StyledTableCell align="center" width="15%">
                                        {pgm.Channel}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  );
                                }
                              })
                            : null}
                        </TableBody>
                      </Table>

                      {selectedData && selectedData.pgm.length > 0
                        ? // eslint-disable-next-line
                          selectedData.pgm.map((pgm, idx) => {
                            if (pgm.Date) {
                              return (
                                <Table className={classes.tableMobile} aria-label="customized table" key={'pgm-' + idx}>
                                  <TableBody>
                                    <StyledTableRow>
                                      <StyledTableCell align="center" width="15%">
                                        Date
                                      </StyledTableCell>
                                      <StyledTableCell align="center" width="15%">
                                        {moment('2022-' + pgm.Date, 'YYYY-DD-MMM').format('YYYY/MM/DD')}
                                      </StyledTableCell>
                                    </StyledTableRow>

                                    {this.getSessionDataMob(pgm.PgmId)}
                                    {/* <StyledTableRow>
                
                                      <StyledTableCell align="center" width="15%">
                                        {pgm.Time}
                                      </StyledTableCell> 
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell align="center" width="15%">
                                        Session/Title
                                      </StyledTableCell>
                                      <StyledTableCell align="center" width="15%" style={{ cursor: 'pointer' }}>
                                        <p>{pgm.Session.replace(/\^&\^/gi, ',')}</p>
                                        <p>{pgm['SpeakerTitle'].replace(/\^&\^/gi, ',')}</p>
                                      </StyledTableCell>
                                    </StyledTableRow> */}
                                    <StyledTableRow>
                                      <StyledTableCell align="center" width="15%">
                                        Role
                                      </StyledTableCell>
                                      <StyledTableCell align="center" width="15%">
                                        {pgm.role}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell align="center" width="15%">
                                        Channel
                                      </StyledTableCell>
                                      <StyledTableCell align="center" width="15%">
                                        {pgm.Channel}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              );
                            }
                          })
                        : null}
                    </TableContainer>
                  </Grid>
                </Grid>

                {selectedData && selectedData.poster && (
                  <React.Fragment>
                    <Grid container justifyContent="space-between" alignItems="center" style={{ padding: '40px 10px 10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <MdImageSearch size={30} style={{ color: this.props.theme.palette.primary.main }} />
                        <span
                          style={{ color: this.props.theme.palette.primary.main, fontWeight: 'bold', paddingLeft: 15, fontSize: '1.2em' }}
                        >
                          E-Poster (&nbsp;{selectedData && selectedData.poster && selectedData.poster.length}&nbsp;)
                        </span>
                      </div>
                    </Grid>
                    <TableContainer>
                      <Table className={classes.tableWeb} aria-label="customized table">
                        <TableHead>
                          <StyledTableRow>
                            <StyledTableCell align="center" width="20%">
                              Type
                            </StyledTableCell>
                            <StyledTableCell align="center" width="40%">
                              Category
                            </StyledTableCell>
                            <StyledTableCell align="center" width="40%">
                              Title
                            </StyledTableCell>
                          </StyledTableRow>
                        </TableHead>
                        <TableBody>
                          {selectedData.poster && selectedData.poster.length > 0
                            ? // eslint-disable-next-line
                              selectedData.poster.map((poster, idx) => {
                                // console.log(selectedData);
                                return (
                                  <StyledTableRow key={`poster-row-${idx}`}>
                                    <StyledTableCell align="center" width="20%">
                                      {poster.type && poster.type}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" width="40%">
                                      {poster.cate && poster.cate}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" width="40%">
                                      {poster.title && poster.title}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                );
                              })
                            : null}
                        </TableBody>
                      </Table>

                      {selectedData.poster && selectedData.poster.length > 0
                        ? // eslint-disable-next-line
                          selectedData.poster.map((poster, idx) => {
                            return (
                              <Table className={classes.tableMobile} aria-label="customized table" key={`poster-row-mob-${idx}`}>
                                <TableBody>
                                  <StyledTableRow>
                                    <StyledTableCell align="center" width="30%">
                                      Type
                                    </StyledTableCell>
                                    <StyledTableCell align="center" width="70%">
                                      {poster.type && poster.type}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell align="center" width="30%">
                                      Category
                                    </StyledTableCell>
                                    <StyledTableCell align="center" width="70%">
                                      {poster.cate && poster.cate}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell align="center" width="30%">
                                      Title
                                    </StyledTableCell>
                                    <StyledTableCell align="center" width="70%">
                                      {poster.title && poster.title}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </TableBody>
                              </Table>
                            );
                          })
                        : null}
                    </TableContainer>
                  </React.Fragment>
                )}
              </Grid>

              <Button
                variant="contained"
                color="primary"
                size="medium"
                style={{ margin: '20px auto 30px' }}
                startIcon={<PrintIcon />}
                onClick={this.onPrint}
                disableElevation
                className={'detail-btn'}
              >
                Print
              </Button>
            </Grid>
          </DialogContent>
          <DialogActions className={`${classes.dialogActions} detail-btn`}>
            <div>
              <Button fullWidth onClick={onClose} style={{ color: '#000000', fontSize: 'large' }}>
                {/* 닫기 */}
                Close
              </Button>
            </div>
          </DialogActions>
        </Dialog>
        {/*{this.state.detail && (*/}
        {/*  <ProgramModal*/}
        {/*    pgmData={this.state.detail}*/}
        {/*    open={this.state.isOpenDetail}*/}
        {/*    onClose={() => this.setState({ isOpenDetail: false })}*/}
        {/*    disableBackdrop={false}*/}
        {/*  />*/}
        {/*)}*/}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FacultyDetail);
